import React from 'react';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home/home";
import { PracticeAreaPage } from './pages/practiceArea/page'
import { Article } from './pages/article/page'
import { Contact } from './pages/contact/page'
import { OurTeam } from './pages/ourteam/page'
import { CreateArticle } from './pages/createarticle/page'
import { Login } from './pages/login/page'
import { Admin } from './pages/admin/page'
import AuthProvider from "./hooks/AuthProvider";
import PrivateRoute from "./hooks/PrivateRoute";
import { EditArticle } from './pages/editarticle/page';
import { ArticleDetail } from './pages/articledetail/page';
import WhatsAppFloat from './components/whatsappfloat/WhatsAppFloat';

export default function App() {
  return (
    <BrowserRouter>
      <WhatsAppFloat />
      <AuthProvider>
        <Routes>
          <Route index element={<Home />} />
          <Route 
            path="practice-area" 
            element={<PracticeAreaPage />} 
          />
          <Route
            path="article-news" 
            element={<Article />} 
          />
          <Route
            path="contact" 
            element={<Contact />} 
          />
          <Route
            path="our-team" 
            element={<OurTeam />} 
          />
          
          <Route
            path="login" 
            element={<Login />} 
          />

          <Route
            path="article/:id"
            element={<ArticleDetail />}
          />

          <Route element={<PrivateRoute />}>
            <Route
              path="create-article" 
              element={<CreateArticle />} 
            />
          </Route>

          <Route element={<PrivateRoute />}>
            <Route
              path="admin" 
              element={<Admin />} 
            />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route
              path="edit-article/:id" 
              element={<EditArticle />} 
            />
          </Route>

        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);